module.exports = __webpack_public_path__ + "static/media/logo.e1ceaf51.png";